import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { push } from "react-router-redux";
import { connect } from 'react-redux';

import SplitPane from "react-split-pane";
import '@zippytech/react-toolkit/SplitContainer/index.css';

import { PlatformHome } from "./dashboard";
import { PlatformDashboard } from './platformDashboard';
import Account from "./account";
import { PlatformUsers } from "./users";
import { AccountUsers } from "./accountUsers";
import { Settings } from "./setting";
import MenuItem from "../common/MenuItem";
import { dispatch } from '@rematch/core';
import './styles.css';
import { Popup } from 'semantic-ui-react';

class Platform extends React.Component {

    componentWillMount() {
        dispatch.app.baseModuleType("Platform");
        let ownedAccount = this.props.user && this.props.user.accounts.filter(account => {
            return account.role === 'customerAdmin'
        });

        if (this.props.user && !this.props.user.isPlatformUser) {
            if (ownedAccount.length === 0) {
                ownedAccount = this.props.user.accounts[0]
            }
            return dispatch(push(`/app/${ownedAccount[0].id}/404`));
        }
    }

    render() {
        const { handleConfigVisibleChange, handleHelpVisibleChange } = this.props;

        return (
            <SplitPane defaultSize="80px" split="vertical" allowResize={false}
                pane1Style={{ backgroundColor: "#fbfbfb" }}
                pane2Style={{ backgroundColor: "#f5f8fa" }} >
                <div className="aspenToolBar">
                    <ul className="aspenMenu topMenu">
                        <div className="vert vert_pt_platform">Platform</div>
                        <MenuItem
                            to={`/app/platform/home`}
                            className="home"
                            name="Home" />
                        <MenuItem
                            to={`/app/platform/dashboard`}
                            className="dashboard"
                            name="Dashboard" />
                        <MenuItem
                            to={`/app/platform/users`}
                            className="users "
                            name="Platform Users" />

                    </ul>
                    <ul className="aspenMenu topMenu">
                        <div className="vert vert_pt_account">Account</div>
                        <MenuItem
                            to={`/app/platform/accountusers`}
                            className="account"
                            name="Account Users" />
                        <MenuItem
                            to={`/app/platform/settings`}
                            className="setting"
                            name="Account Settings" />
                    </ul>
                    <ul className="aspenMenu bottomMenu top_brdr">
                        <div className="vert vert_settings_help">Settings & Help</div>
                        <li title="Settings"><a href="#" className="settings" onClick={handleConfigVisibleChange} >Settings</a></li>
                        <li><Popup trigger={<a className="help" onClick={handleHelpVisibleChange} style={{cursor: 'pointer'}} >
                            {"Visit Aspenify Support"}
                            </a>}
                            content={"Visit Aspenify Support"}
                            position='right center'
                            inverted
                            />
                        </li>
                    </ul>
                </div>

                <div className="mainContent" >
                    <Switch>
                        <Route path="/app/platform/home" component={PlatformHome} />
                        <Route path="/app/platform/dashboard" component={PlatformDashboard} />
                        <Route path="/app/platform/account" component={Account} />
                        <Route path="/app/platform/users" component={PlatformUsers} />
                        <Route path="/app/platform/accountusers" component={AccountUsers} />
                        <Route path="/app/platform/settings" component={Settings} />
                    </Switch>
                </div>
            </SplitPane>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.app.user,
        integrationsList:state.integrations.integrationsList
    };
}

const connectedPlatform = withRouter(connect(mapStateToProps)(Platform));

export default connectedPlatform;
